import { useParams } from 'react-router-dom';
import { UserLevels } from '../../services/UserLevels';
import { UserRoles } from '../../services/UserRoles';
import { EntityForm } from '../EntityForm';
import { Api } from '../../services/Api';
import { SubOrgUnitEditor } from './SubOrgUnitEditor';
import { subOrgUnitSchema } from './SubOrgUnitValidation';

export function SubOrgUnitDetail() {
    const { id } = useParams();

    const newEntity = ({ user }) => {
        return {
            name: '',
            tenant: user.scope.tenant,
            orgUnit: user.scope.orgUnit,
        };
    }

    return (
        <EntityForm
            id={id}
            pageTitle="Sous-organisations"
            validationSchema={subOrgUnitSchema}
            listUrl="/admin/suborgunits/"
            getEntityDisplay={({ value }) => value?.name || ''}
            newEntity={newEntity}
            getEntity={({ id }) => Api.getSubOrgUnit(id)}
            createEntity={({ value }) => Api.createSubOrgUnit(value)}
            updateEntity={({ value }) => Api.updateSubOrgUnit(value.id, value)}
            removeEntity={({ id }) => Api.removeSubOrgUnit(id)}
            canEdit={({ user }) => user && user.role >= UserRoles.ADMIN && user.level >= UserLevels.ORGUNIT}
            canDelete={({ user }) => user && user.role >= UserRoles.ADMIN && user.level >= UserLevels.ORGUNIT}>
            {(props) => <SubOrgUnitEditor {...props} />}
        </EntityForm>
    );
}